<template>
  <div class="flex flex-col gap-5">
    <h2 class="capitalize-first text-xl font-medium">
      {{ $t('global.other_place') }}
    </h2>

    <div class="grid grid-cols-2 gap-3">
      <div
        v-if="availablePlaceType.includes('RUE')"
        class="flex flex-col gap-3 rounded-md border"
        :class="[placeType === 'RUE' ? 'bg-blue-50 shadow-lg' : '']"
      >
        <button class="flex items-start p-3" @click="handleSelectOther('RUE')">
          <div class="text-center lg:mt-0 lg:text-left">
            <p
              class="capitalize-first cursor-pointer font-medium select-none"
              v-text="$t('attributes.RUE')"
            />
          </div>
        </button>
      </div>
      <div
        v-if="availablePlaceType.includes('OTHER')"
        class="flex flex-col gap-3 rounded-md border"
        :class="[placeType === 'OTHER' ? 'bg-blue-50 shadow-lg' : '']"
      >
        <button
          class="flex items-start p-3"
          @click="handleSelectOther('OTHER')"
        >
          <div class="text-center lg:mt-0 lg:text-left">
            <p
              class="capitalize-first cursor-pointer font-medium select-none"
              v-text="$t('attributes.OTHER')"
            />
          </div>
        </button>
      </div>
    </div>
    <template v-if="[PlaceType.AUTRES, PlaceType.RUE].includes(placeType)">
      <div>
        <BaseShowEditInput
          v-model="localPlaceOther"
          :label="$t('attributes.place')"
          edition-mode
        />
      </div>
      <div>
        <BaseShowEditAddress
          v-model:street="localPlaceStreet"
          v-model:extra-street="localPlaceExtraStreet"
          v-model:zip="localPlaceZip"
          v-model:city="localPlaceCity"
          v-model:city-id="localPlaceCityId"
          v-model:country="localPlaceCountry"
          v-model:current-city-object="localPlaceCityObject"
          :required-city="requiredCity"
          edition-mode
        />
      </div>
      <div
        v-if="(requiredCity && localPlaceCity) || !requiredCity"
        class="flex flex-row justify-end"
      >
        <BaseButton :title="$t('button.save')" @click="handleSave" />
      </div>
    </template>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import BaseShowEditAddress from '@c/BaseShowEditAddress.vue'
import BaseButton from '@c/addf-package/components/BaseButton/BaseButton.vue'
import BaseShowEditInput from '@c/addf-package/components/BaseShowEditInput/BaseShowEditInput.vue'
import PlaceType from '@/assets/enums/config/PlaceType'

export default {
  name: 'SelectOtherPlace',
  components: { BaseShowEditInput, BaseButton, BaseShowEditAddress },
  props: {
    placeModel: {
      type: Object,
      required: true
    },
    placeType: {
      type: String,
      required: true
    },
    placeId: {
      type: [String, Number],
      required: true
    },
    placeOther: {
      type: String,
      required: false,
      default: null
    },
    placeStreet: {
      type: String,
      required: false,
      default: null
    },
    placeExtraStreet: {
      type: String,
      required: false,
      default: null
    },
    placeZip: {
      type: String,
      required: false,
      default: null
    },
    placeCity: {
      type: String,
      required: false,
      default: null
    },
    placeCityObject: {
      type: Object,
      required: false,
      default: () => {}
    },
    placeCountry: {
      type: String,
      required: false,
      default: null
    },
    availablePlaceType: {
      type: Array,
      required: true
    },
    requiredCity: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: [
    'update:placeType',
    'update:placeId',
    'update:placeName',
    'close',
    'update:placeModel',
    'update:placeOther',
    'update:placeStreet',
    'update:placeExtraStreet',
    'update:placeCity',
    'update:placeCityId',
    'update:placeCityObject',
    'update:placeZip',
    'update:placeCountry'
  ],
  data() {
    return {
      oldPlaceName: null
    }
  },
  computed: {
    PlaceType() {
      console.log(this.availablePlaceType)
      return PlaceType
    },
    ...mapGetters({
      // dossier: "dossier/getDossier",
      // dossierMetadata: "dossier/getDossierMetadata",
      // funeralHomes: 'metadata/getFuneralHomesMetadata'
    }),
    localPlaceOther: {
      get() {
        return this.placeOther
      },
      set(value) {
        this.$emit('update:placeOther', value)
      }
    },
    localPlaceStreet: {
      get() {
        return this.placeStreet
      },
      set(value) {
        this.$emit('update:placeStreet', value)
      }
    },
    localPlaceExtraStreet: {
      get() {
        return this.placeExtraStreet
      },
      set(value) {
        this.$emit('update:placeExtraStreet', value)
      }
    },
    localPlaceCity: {
      get() {
        return this.placeCity
      },
      set(value) {
        this.$emit('update:placeCity', value)
      }
    },
    localPlaceCityId: {
      get() {
        return this.placeCityId
      },
      set(value) {
        this.$emit('update:placeCityId', value)
      }
    },
    localPlaceCityObject: {
      get() {
        return this.placeCityObject
      },
      set(value) {
        this.$emit('update:placeCityObject', value)
      }
    },
    localPlaceZip: {
      get() {
        return this.placeZip
      },
      set(value) {
        this.$emit('update:placeZip', value)
      }
    },
    localPlaceCountry: {
      get() {
        return this.placeCountry
      },
      set(value) {
        this.$emit('update:placeCountry', value)
      }
    },
    required() {
      return this.requiredCity
    }
  },
  methods: {
    handleSelectOther(type) {
      this.$emit('update:placeType', type)

      this.$emit('update:placeId', null)
      this.$emit('update:placeModel', {
        name: this.placeOther,
        city: this.placeCity,
        country: this.placeCountry,
        street: this.placeStreet,
        zip: this.placeZip
      })
    },
    handleSave() {
      this.handleSelectOther(this.placeType)
      this.$emit('close', true)
    }
  }
}
</script>
